import { createSlice } from "@reduxjs/toolkit"
import { Workflow } from "@/api/workflows"

export const workflowsSlice = createSlice({
    name: "workflows",
    initialState: {
        workflowJSON: "",
        isWorkflowRunning: false,
        workflows: [] as Workflow[],
        workflowsPaginationModel: { pageSize: 10, page: 0 },
        workflowsSortModel: [{ field: "created_time_utc", sort: "desc" }],
        workflowsTotalCount: 0,
        isWorkflowJsonViewOpened: false,
        selectedWorkflow: null as Workflow | null,
        workflowsSearchQuery: "",
        workflowsDatePreset: "all",
        workflowsDateRange: [null, null] as [string | null, string | null],
    },
    reducers: {
        setWorkflowJSON: (state, action) => {
            state.workflowJSON = action.payload
        },
        setIsWorkflowRunning: (state, action) => {
            state.isWorkflowRunning = action.payload
        },
        setWorkflows: (state, action) => {
            state.workflows = action.payload
        },
        setWorkflowsPaginationModel: (state, action) => {
            state.workflowsPaginationModel = action.payload
        },
        setWorkflowsSortModel: (state, action) => {
            state.workflowsSortModel = action.payload
        },
        setWorkflowsTotalCount: (state, action) => {
            state.workflowsTotalCount = action.payload
        },
        setIsWorkflowJsonViewOpened: (state, action) => {
            state.isWorkflowJsonViewOpened = action.payload
        },
        setSelectedWorkflow: (state, action) => {
            state.selectedWorkflow = action.payload
        },
        setWorkflowsSearchQuery: (state, action) => {
            if (state.workflowsSearchQuery !== action.payload) {
                state.workflowsPaginationModel.page = 0
            }
            state.workflowsSearchQuery = action.payload
        },
        setWorkflowsDatePreset: (state, action) => {
            state.workflowsDatePreset = action.payload
        },
        setWorkflowsDateRange: (state, action) => {
            state.workflowsDateRange = action.payload
        },
    },
})

export const {
    setWorkflowJSON,
    setIsWorkflowRunning,
    setWorkflows,
    setWorkflowsPaginationModel,
    setWorkflowsSortModel,
    setWorkflowsTotalCount,
    setIsWorkflowJsonViewOpened,
    setSelectedWorkflow,
    setWorkflowsSearchQuery,
    setWorkflowsDatePreset,
    setWorkflowsDateRange,
} = workflowsSlice.actions

export default workflowsSlice.reducer
